/* AuthCallback — traite le retour Emergent Google Auth (#session_id=...).
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { resolvePostLoginTarget } from "@/lib/postLogin";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? decodeURIComponent(match[1]) : null;
    (async () => {
      if (!sessionId) { navigate("/login", { replace: true }); return; }
      try {
        await api.post("/auth/google/session", { session_id: sessionId });
        window.history.replaceState(null, "", window.location.pathname);
        await refresh();
        const target = await resolvePostLoginTarget("/app/executive");
        navigate(target, { replace: true });
      } catch (e) {
        const detail = e?.response?.data?.detail || "Connexion Google impossible. Réessayez.";
        setError(detail);
        try { sessionStorage.setItem("noam_google_error", detail); } catch { /* silent */ }
        setTimeout(() => navigate("/login", { replace: true }), 1200);
      }
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0A0E13] text-zinc-300" data-testid="auth-callback">
      <div className="flex flex-col items-center gap-3 text-sm">
        {error ? (
          <div className="text-[#FCA5A5] text-xs max-w-sm text-center">{error}</div>
        ) : (
          <>
            <Loader2 className="w-5 h-5 animate-spin text-[#378ADD]" />
            Connexion sécurisée en cours…
          </>
        )}
      </div>
    </div>
  );
}
